import { createButton } from 'src/library/minigame_client/ui/common/ui'
import {lang} from "./library/lang";

export default class AccountChangedWindow extends PIXI.Container
{
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;

        const config = configGame.AccountChangedWindow;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");

        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "background_utility.png"]);
        this.background.position.set(config.background.pos.x, config.background.pos.y);
        this.addChild(this.background);

        this.buttonOk = createButton(this.background, config.buttonOk.pos.x, config.buttonOk.pos.y, packFolder + "ok_info", this.sndBtnClick);
        this.buttonOk.callback = function() {self.visible = false};

        const translateList = {
            name: {
                rus: 'Счет сменился',
                eng: 'Account has changed'
            }
        };

        const lng = lang();

        this.labelTitle = new PIXI.Text(translateList.name[lng], config.labelTitle.font);
        this.labelTitle.position.set(this.background.width/2, this.background.height/2);
        this.labelTitle.anchor.set(0.5, 0.5);
        this.background.addChild(this.labelTitle);

        this.visible = false;
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.layerBlockInput = null;
        this.background = null;
        this.buttonOk = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
    }
}


// WEBPACK FOOTER //
// ./src/account_changed_window.es6